const WhiteLogo = () => {
  return (
    <svg
      width="64"
      height="30"
      viewBox="0 0 84 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M64.0156 0.140625H40.7718L33.913 12.1435L27.0542 0.140625H16.5755L28.7689 21.0981L25.53 26.2422L10.4787 0.140625H0L22.8627 39.7693H28.1973L33.7225 30.0527L39.2477 39.7693H44.5823L53.3463 24.5275H62.3009L67.445 15.573H48.2022L41.915 26.2422L39.0571 21.0981L45.916 9.09519H64.0156C69.9218 9.09519 74.8754 13.8583 74.8754 19.955C74.8754 26.0517 70.1123 30.8148 64.0156 30.8148H55.6326L50.679 39.7693H63.8251C74.6849 39.7693 83.6394 30.8148 83.6394 19.955C83.6394 9.09519 74.8754 0.140625 64.0156 0.140625Z"
        fill="white"
      />
    </svg>
  );
};

export default WhiteLogo;
